import { PageSize } from '@/constant';
import {
	IDeviceTabletItem,
	IGetDeviceTabletListParams,
} from '@/services/api/api.type';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDeviceTabletListRequest,
	IPayloadGetDeviceTabletListSuccess,
	IPayloadVerifyTabletRegisterCodeRequest,
	IPayloadVerifyTabletRemoteCodeRequest,
} from './device-tablet.type';

const InitParams: IGetDeviceTabletListParams = {
	page: 1,
	pageSize: PageSize.XS,
};

const initialState = {
	fetching: false,
	list: [] as IDeviceTabletItem[],
	total: 0,
	params: InitParams,
	// Actions
	submitting: false,
};

const deviceTabletSlice = createSlice({
	initialState,
	name: 'deviceTablet',
	reducers: {
		/**---- GET DEVICE_TABLET LIST START ---- */
		getDeviceTabletListRequest: (
			state,
			_action: PayloadAction<IPayloadGetDeviceTabletListRequest>
		) => {
			state.fetching = true;
			state.params = _action?.payload;
		},
		getDeviceTabletListSuccess: (
			state,
			action: PayloadAction<IPayloadGetDeviceTabletListSuccess>
		) => {
			const { list, totalCount } = action.payload;
			state.fetching = false;
			state.list = list;
			state.total = totalCount;
		},
		getDeviceTabletListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET DEVICE_TABLET LIST END ---- */

		/**---- VERIFY TABLET REGISTER CODE START ---- */
		verifyTabletRegisterCodeRequest: (
			state,
			_action: PayloadAction<IPayloadVerifyTabletRegisterCodeRequest>
		) => {
			state.submitting = true;
		},
		verifyTabletRegisterCodeSuccess: (state) => {
			state.submitting = false;
		},
		verifyTabletRegisterCodeFailure: (state) => {
			state.submitting = false;
		},
		/**---- VERIFY TABLET REGISTER CODE END ---- */

		/**---- VERIFY TABLET REMOTE CODE START ---- */
		verifyTabletRemoteCodeRequest: (
			state,
			_action: PayloadAction<IPayloadVerifyTabletRemoteCodeRequest>
		) => {
			state.submitting = true;
		},
		verifyTabletRemoteCodeSuccess: (state) => {
			state.submitting = false;
		},
		verifyTabletRemoteCodeFailure: (state) => {
			state.submitting = false;
		},
		/**---- VERIFY TABLET REMOTE CODE END ---- */
	},
});

export const DeviceTabletSelectors = {
	selectFetching: (state: RootState) => state.deviceTablet.fetching,
	selectList: (state: RootState) => state.deviceTablet.list,
	selectTotal: (state: RootState) => state.deviceTablet.total,
	selectParams: (state: RootState) => state.deviceTablet.params,
	selectSubmitting: (state: RootState) => state.deviceTablet.submitting,
};

export const DeviceTabletActions = deviceTabletSlice.actions;
export const DeviceTabletReducer = deviceTabletSlice.reducer;
